import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { MyHttpClient } from '../../app/http-client.service';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GuestAdjustmentService {
  server = environment.server;
  baseUrl = `${this.server}/api/wallet/guest`;

  constructor(private http: MyHttpClient) {}

  creditGuestWallet(requestBody: object) {
    return this.http.post(`${this.baseUrl}/wallet/credit`, requestBody).pipe(catchError(this.handleError));
  }

  debitGuestWallet(requestBody: object) {
    return this.http.post(`${this.baseUrl}/wallet/debit`, requestBody).pipe(catchError(this.handleError));
  }

  getTransactionsByOrder(profileId: string, orderId: string) {
    return this.http.get(`${this.server}/api/wallet/guest/${encodeURIComponent(profileId)}/walletTransactions?orderId=${encodeURIComponent(orderId)}&limit=50`)
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
    } else {
      console.error(`Backend returned code ${error.status}, body was: ${error.error}`);
    }
    return throwError(error);
  }
}
